import { useQuery } from '@tanstack/react-query';

import { getTopupEligibility, type TopupEligibility } from '@/services/topup';
import { useAuth } from '@/contexts/auth';

export type { TopupEligibility };

export default function useTopupEligibility({
  enabled = true,
  slug,
}: { enabled?: boolean; slug?: string } = {}) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['topup-eligibility', user?.user_id ?? null, slug ?? null],
    queryFn: () => getTopupEligibility(slug),
    enabled: enabled && !!user?.user_id,
    // WHEN_ZERO_CREDITS reads spendable credits, which bookings and waitlist
    // holds change on other pages.
    refetchOnMount: true,
  });
}
